import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/BreadCrumb";
import { DropdownAddButton } from "../../components/micro/input";
import DebounceSearch from "../../components/common/DebounceSearch";
import CustomTable from "../../components/customTable/CustomTable";
import { SortDownArrow } from "../../assets/svg";
import Action from "../../components/common/Action";
import { useDispatch, useSelector } from "react-redux";
import RippleLoader from "../../components/RippleLoader/RippleLoader";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import { useNavigate } from "react-router-dom";
import {
  deleteStaff,
  getStaffsList,
  updateStaffStatus,
} from "../../redux/staffs/slice";
import Toggles from "../../components/common/Toggles";

const StaffAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);
  const [confirmArchive, setConfirmArchive] = useState(false);
  const [confirmUnarchive, setConfirmUnarchive] = useState(false);
  const [staffIdToArchive, setStaffIdToArchive] = useState(null);
  const [staffIdToUnarchive, setStaffIdToUnarchive] = useState(null);
  const [staffIdToDelete, setStaffIdToDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedTab, setSelectedTab] = useState("hq");
  const [activeTab, setActiveTab] = useState("active");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);

  const tabs = [
    { label: "HQ", value: "hq" },
    { label: "Manager", value: "manager" },
    { label: "Outlet's Staff", value: "outlet_staff" },
  ];

  // selector
  const { staffsList, staffsListLoading } = useSelector((store) => ({
    staffsList: store?.staffsData?.getStaffsListStatus?.data,
    staffsListLoading: store?.staffsData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getStaffsList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        status: activeTab === "archived" ? "archive" : activeTab,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        staff_type: selectedTab,
      })
    );
  }, [
    searchValue,
    pageCount,
    pageLimit,
    activeTab,
    sortBy,
    sortDirection,
    selectedTab,
  ]);

  const updateStatus = (element, status, isActive) => {
    dispatch(
      updateStaffStatus({
        id: element?.id,
        data: {
          status: status,
          is_active: isActive,
        },
      })
    ).then((res) => {
      if (res.type === "updateStaffStatus/fulfilled") {
        dispatch(
          getStaffsList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            staff_type: selectedTab,
          })
        );
      }
    });
  };

  const handleArchive = () => {
    const staffToArchive = staffsList?.data?.data?.find(
      (staff) => staff.id === staffIdToArchive
    );

    if (staffToArchive) {
      updateStatus(staffToArchive, "archive", false);
    }
    setConfirmArchive(false);
  };

  const handleUnarchive = () => {
    const staffToUnarchive = staffsList?.data?.data?.find(
      (staff) => staff.id === staffIdToUnarchive
    );

    if (staffToUnarchive) {
      updateStatus(staffToUnarchive, "active", true);
    }
    setConfirmUnarchive(false);
  };

  const handelSaleDelete = () => {
    setIsLoading(true);
    if (!staffIdToDelete) return;
    dispatch(deleteStaff(staffIdToDelete)).then((res) => {
      if (res.type === "deleteStaff/fulfilled") {
        dispatch(
          getStaffsList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            staff_type: selectedTab,
          })
        );
      }
      setIsLoading(false);
      setConfirmDelete(false);
    });
  };

  const handleToggle = (element) => {
    const newStatus = element.status === "active" ? "inactive" : "active";
    const isActive = newStatus === "active";

    updateStatus(element, newStatus, isActive);
  };

  // Table Headers
  const ColumnHeaders = () => (
    <>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        ID
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Name</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "name" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        {selectedTab === "hq" ? (
          <div
            className="flex items-center"
            onClick={() => {
              setSortBy("role");
              setSortDirection(sortDirection === "desc" ? "asc" : "desc");
            }}
          >
            <span>Role </span>
            <SortDownArrow
              className={`ml-1 transition-transform duration-300 ${
                sortDirection === "asc" && sortBy === "role" ? "rotate-180" : ""
              }`}
            />
          </div>
        ) : (
          <div
            className="flex items-center"
            onClick={() => {
              setSortBy("outlet");
              setSortDirection(sortDirection === "desc" ? "asc" : "desc");
            }}
          >
            <span>Outlet </span>
            <SortDownArrow
              className={`ml-1 transition-transform duration-300 ${
                sortDirection === "asc" && sortBy === "outlet"
                  ? "rotate-180"
                  : ""
              }`}
            />
          </div>
        )}
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Mobile
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Email
      </th>
      {activeTab === "active" && (
        <th
          scope="col"
          className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
        >
          <div className="flex items-center">
            <span>Status</span>
          </div>
        </th>
      )}
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Action
      </th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(staffsList?.data?.data || [])?.map((element, index) => (
        <tr
          key={element.id}
          className="text-sm shadow-sm text-mgrey hover:bg-lightprimaryorange font-Proxima"
        >
          <td className="px-5 py-3 truncate">{element?.id}</td>
          <td className="px-5 py-3 truncate">
            {element?.full_name
              ? element?.full_name
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-5 py-3">
            {selectedTab === "hq" ? (
              element?.role ? (
                element.role
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              ) : (
                "-"
              )
            ) : element?.outlets ? (
              <div>{element.outlets}</div>
            ) : (
              "-"
            )}
          </td>

          <td className="px-5 py-3 truncate">{element?.phone}</td>
          <td className="px-5 py-3 truncate">{element?.email}</td>
          {activeTab === "active" && (
            <td className="px-5 py-3 truncate">
              <Toggles
                checked={element?.status === "active"}
                toggleFor={element?.id}
                onChange={() => handleToggle(element)}
              />
            </td>
          )}
          <td className="flex px-5 py-3">
            {activeTab === "active" ? (
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() =>
                        navigate("/create-edit-staff-account", {
                          state: { staff: element, mode: "edit" },
                        })
                      }
                    >
                      View/Edit
                    </li>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setConfirmArchive(true);
                        setStaffIdToArchive(element?.id);
                      }}
                    >
                      Archive
                    </li>
                  </>
                }
              />
            ) : (
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setConfirmUnarchive(true);
                        setStaffIdToUnarchive(element?.id);
                      }}
                    >
                      Unarchive
                    </li>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setConfirmDelete(true);
                        setStaffIdToDelete(element?.id);
                      }}
                    >
                      Delete
                    </li>
                  </>
                }
              />
            )}
          </td>
        </tr>
      ))}
    </>
  );

  const dropdownOptions = [
    {
      label: "Add HQ Staff",
      route: "/create-edit-staff-account",
      state: { mode: "hq" },
    },
    {
      label: "Add Outlet manager",
      route: "/create-edit-staff-account",
      state: { mode: "manager" },
    },
    {
      label: "Add Outlet Staff",
      route: "/create-edit-staff-account",
      state: { mode: "outlet_staff" },
    },
  ];

  const handleDropdownSelect = (option) => {
    setModalMode(option?.state?.mode);
    setIsModalOpen(true);
  };

  return (
    <>
      <div>
        <div className="flex justify-between items-start">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Staff Account
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Staff Account"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
          {activeTab === "active" && (
            <div>
              <DropdownAddButton
                value="Add Staff"
                options={dropdownOptions}
                onClick={handleDropdownSelect}
              />

              {isModalOpen &&
                modalMode &&
                navigate("/create-edit-staff-account", {
                  state: { mode: modalMode },
                })}
            </div>
          )}
        </div>

        <div className="flex justify-end mt-8">
          {tabs?.map((tab) => (
            <button
              key={tab.value}
              className={`py-2 w-full font-normal mb-5 h-full px-4 uppercase text-sm border-b-2 transition duration-300 font-Proxima ${
                selectedTab === tab.value
                  ? "border-themeBtn text-themeBtn"
                  : "border-transparent text-textSecondary hover:text-themeBtn hover:border-theme text-gray-dark"
              }`}
              onClick={() => setSelectedTab(tab.value)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="flex mb-4 w-full">
          {["active", "archived"].map((el, index) => (
            <button
              key={el}
              className={`transition font-Proxima uppercase duration-300 text-sm font-normal px-4 py-1.5 w-full
        ${index === 0 ? "!rounded-l !rounded-r-none" : ""}
        ${index === 1 ? "!rounded-r !rounded-l-none" : ""}
        ${
          activeTab === el
            ? "border-themeBtn text-themeBtn border bg-disableThemeBtn"
            : "border-themeBtn text-themeBtn border"
        }`}
              onClick={() => setActiveTab(el)}
            >
              {el}
            </button>
          ))}
        </div>
        <div className="flex items-center space-x-3">
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
        </div>
        {staffsListLoading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg mt-5 overflow-x-auto">
            <div className="min-w-[600px]">
              <CustomTable
                columnHeaders={<ColumnHeaders />}
                dataRows={<DataRows />}
                data={staffsList?.data}
                overflowVisibleLg={true}
                loading={false}
                showPagination={true}
                setPaginationCurrentLimit={setPageLimit}
                paginationCurrentLimit={pageLimit}
                total={staffsList?.data?.total}
                current={pageCount}
                paginationData={(crPage) => setPageCount(crPage)}
                lastPage={Math.ceil(staffsList?.data?.total / pageLimit)}
              />
            </div>
          </div>
        )}
      </div>
      {confirmArchive && (
        <div>
          <ConfirmationModel
            confirmText={"Archive"}
            onClose={() => {
              setConfirmArchive(false);
            }}
            onConfirm={handleArchive}
          />
        </div>
      )}

      {confirmUnarchive && (
        <div>
          <ConfirmationModel
            confirmText={"Unarchive"}
            onClose={() => {
              setConfirmUnarchive(false);
            }}
            onConfirm={handleUnarchive}
          />
        </div>
      )}
      {confirmDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              setConfirmDelete(false);
            }}
            onConfirm={handelSaleDelete}
            isLoading={isLoading}
          />
        </div>
      )}
    </>
  );
};

export default StaffAccount;
